import { schema } from 'normalizr'

const profileSchema = new schema.Entity('profile')
const answerSchema = new schema.Entity('answer')
const contactSchema = new schema.Entity('contact')
const automationSchema = new schema.Entity('automation')
const userSchema = new schema.Entity('user')
const analyticsEventSchema = new schema.Entity('analyticsEvent')

profileSchema.define({
  automations: [automationSchema],
})

userSchema.define({})

answerSchema.define({})

contactSchema.define({})

automationSchema.define({
  followerAnswers: [answerSchema],
  notFollowerAnswers: [answerSchema],
})

analyticsEventSchema.define({
  automation: automationSchema,
  contact: contactSchema,
  answer: answerSchema,
})

export {
  profileSchema,
  userSchema,
  automationSchema,
  answerSchema,
  contactSchema,
  analyticsEventSchema,
}
